import { DetailForm } from '@/@diffrag/form/DetailForm'
import { FormFieldType } from '@/@diffrag/form/fields/type'
import { useApi } from '@/@diffrag/hooks/useApi'
import { useQueryValue } from '@/@diffrag/hooks/useQueryValue'
import { ContentDetailView } from '@/@diffrag/layout/ContentDetailView'
import { api } from '@/api'
import {
  IAdminBusinessInquiryUpdate,
  IAdminBusinessInquiryUpdateStatusEnum,
} from 'api'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'

export default function InquiryEdit() {
  const navigate = useNavigate()
  const id = useQueryValue('id', '')
  const { data } = useApi({
    id: 'inquiryDetail',
    fn: api().adminBusinessInquiry.adminBusinessInquiryDetail,
    params: Number(id),
    enabled: !!id,
  })

  const onSave = async (data: any) => {
    if (!confirm('저장하시겠습니까?')) {
      return
    }

    if (id) {
      const updateData: IAdminBusinessInquiryUpdate = {
        status: data.status as unknown as IAdminBusinessInquiryUpdateStatusEnum,
        memo: data.memo || '',
        contactDate: data.contactDate
          ? new Date(data.contactDate).toISOString()
          : undefined,
      }

      await api().adminBusinessInquiry.adminBusinessInquiryUpdate(
        Number(id),
        updateData,
      )
      navigate(-1)
      toast.success('저장되었습니다.')
    }
  }

  const onDelete = async () => {
    if (id) {
      await api().adminBusinessInquiry.adminBusinessInquiryDelete(Number(id))
    }
  }

  return (
    <ContentDetailView
      title="제휴문의 수정"
      data={data}
      hideSaveToast={() => true}
      onSave={onSave}
      onDelete={onDelete}
    >
      <DetailForm
        data={data}
        fields={[
          {
            label: '병원명',
            key: 'clinicName',
            type: FormFieldType.STRING,
            readOnly: true,
          },
          {
            label: '성함',
            key: 'name',
            type: FormFieldType.STRING,
            readOnly: true,
          },
          {
            label: '직함',
            key: 'position',
            type: FormFieldType.STRING,
            readOnly: true,
          },
          {
            label: '연락처',
            key: 'phoneNumber',
            type: FormFieldType.STRING,
            readOnly: true,
          },
          {
            label: '이메일',
            key: 'email',
            type: FormFieldType.STRING,
            readOnly: true,
          },
          {
            label: '문의내용',
            key: 'content',
            type: FormFieldType.TEXT,
            readOnly: true,
          },
          {
            key: 'status',
            label: '상태',
            type: FormFieldType.SELECT,
            options: [
              { label: '대기', value: 'PENDING' },
              { label: '컨택중', value: 'CONTACTING' },
              { label: '컨택완료', value: 'CONTACT_COMPLETED' },
              { label: '제휴완료', value: 'PARTNERSHIP_COMPLETED' },
              { label: '보류', value: 'ON_HOLD' },
              { label: '종료', value: 'ENDED' },
            ],
          },
          {
            label: '메모',
            key: 'memo',
            type: FormFieldType.TEXT,
          },
          {
            label: '문의날짜',
            key: 'createDate',
            type: FormFieldType.DATE,
            readOnly: true,
          },
          {
            label: '컨택날짜',
            key: 'contactDate',
            type: FormFieldType.DATE,
          },
        ]}
      />
    </ContentDetailView>
  )
}
